import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userLocationSlice from "./userLocation/userLocationSlice";
import userProfileSlice from "./userProfile/userProfileSlice";
import userPaymentMethodsSlice from "./userPaymentMethods/userPaymentMethodsSlice";
import countriesSlice from "./countries/countriesSlice";
import messageSlice from "./message/messageSlice";
import userSubscriptionSlice from "./userSubscription/userSubscriptionSlice";

const rootReducer = combineReducers({
  userLocationSlice,
  userProfileSlice,
  userPaymentMethodsSlice,
  countriesSlice,
  messageSlice,
  userSubscriptionSlice,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
